import { Arg, COMPONENT_STATE_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import { fn } from '@ember/helper';
import { gt, not, reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import Super from '../core/base.gjs';
import Tag from '../indicator/tag.gjs';
import styles from './multiselect-clear-filter.module.scss';

const METADATA = Metadata.define({
  description:
    'Shared button for clearing multiselect lists. Wraps SPDS::Tag component filter variant',
  extends: [pick(COMPONENT_STATE_ARGS, ['disabled'])],
  meta: {
    clearSelection: Arg.action({
      description: 'Action to be called when the clear button is clicked',
    }).required(),
    selected: Arg.array({ description: 'Array of selected items' }).initial([1, 2, 3]),
  },
  name: 'Multiselect Clear Filter',
});

export default class SpdsInputMultiselectClearFilter extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-multiselect-clear-filter';
  classesToMap = ['hidden'];
  styles = styles;

  @tracked tagComponent;

  @gt('selectedCount', 0) hasMultiselectOptions;

  @not('hasMultiselectOptions') hidden;

  @reads('tagComponent.clearButton') clearButton;
  @reads('selected.length') selectedCount;

  get selected() {
    return this.argOrDefault('selected');
  }

  clearSelection = (...args) => {
    let evt = args.pop();

    evt.stopPropagation();
    evt.target.classList.remove('active');

    this.args.clearSelection(...args, evt);
  };

  <template>
    <Tag
      @disabled={{@disabled}}
      @label="{{this.selectedCount}} selected"
      @type="filter"
      @onClose={{this.clearSelection}}
      @registerComponent={{fn this.registerComponent "tagComponent"}}
      @unregisterComponent={{fn this.unregisterComponent "tagComponent"}}
      class={{this.classes}}
      data-test-spds-multiselect-clear-button
      {{this.validateArguments}}
      ...attributes
    />
  </template>
}

export const SPDS_INPUT_MULTISELECT_CLEAR_FILTER_METADATA =
  SpdsInputMultiselectClearFilter.metadata;
